export default __webpack_public_path__ + "static/media/planetarium.28d31eba.jpg";